import { useFormik } from "formik";
import TextInput from "../../components/inputs/textInput";
import FileInput from "../../components/inputs/fileInput";
import Button from "../../components/buttons/button";
import { useOptions } from "../../components/hooks/useOptionsHook";
import Select from "../../components/select/select";
import * as yup from "yup";

const AddMember = ({ t, setOpen }) => {
  const validationSchema = yup.object({
    name: yup.string().required(t("required")),
    id: yup
      .string()
      .matches(/^[0-9]+$/, "يجب أن يكون رقم الهوية أرقامًا فقط")
      .required(t("required")),
    phone: yup
      .string()
      .matches(/^(\+?\d{1,3}[- ]?)?\d{10}$/, "رقم الهاتف غير صحيح")
      .required(t("required")),
    nationality: yup.string().required(t("required")),
    status: yup.string().required(t("required")),
    membershipType: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      name: "",
      id: "",
      phone: "",
      nationality: "",
      status: "",
      membershipType: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setOpen(false);
    },
  });
  const { memberShipTypeOptions, memberStatusOptions } = useOptions();
  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <div className="inputs">
        <TextInput formik={formik} name={"name"} label={t("fullName")} />
        <TextInput formik={formik} name={"id"} label={t("idNumber")} />
      </div>
      <div className="inputs">
        <TextInput formik={formik} name={"phone"} label={t("phone")} />
        <TextInput formik={formik} name={"nationality"} label={t("nationality")} />
      </div>
      <div className="inputs">
        <Select
          options={memberStatusOptions}
          formik={formik}
          name={"status"}
          label={t("status")}
        />
        <Select
          options={memberShipTypeOptions}
          formik={formik}
          name={"membershipType"}
          label={t("membershipType")}
        />
      </div>
      <FileInput
        formik={formik}
        id={"profile"}
        name={"profile"}
        label={t("uploadPhoto/id")}
      />
      <div className="flex items-center justify-end gap-3">
        <Button
          className={"border border-white text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
        <Button className={"bg-primary justify-center w-[130px] text-black text-sm"}>
          {t("add")}
        </Button>
      </div>
    </form>
  );
};

export default AddMember;
